import { render } from "./IndexTabs.vue?vue&type=template&id=739d2519&scoped=true&ts=true"
import script from "./IndexTabs.vue?vue&type=script&lang=ts"
export * from "./IndexTabs.vue?vue&type=script&lang=ts"

import "./IndexTabs.vue?vue&type=style&index=0&id=739d2519&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739d2519"]])

export default __exports__